var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value != null)?_c('span',{attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.durationString))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }